export { default as BleedSectionLandscapeLeft } from './BleedSectionLandscapeLeft';
export { default as BleedSectionLandscapeRight } from './BleedSectionLandscapeRight';
export { default as BleedSectionPortraitLeft } from './BleedSectionPortraitLeft';
export { default as BleedSectionPortraitRight } from './BleedSectionPortraitRight';
export { default as BleedSectionSplitLeft } from './BleedSectionSplitLeft';
export { default as BleedSectionSplitRight } from './BleedSectionSplitRight';



// WEBPACK FOOTER //
// ./src/modules/pages/components/sections/index.js